import { IconType } from '@bt-react/components/Icon'
import { status } from '@bt-react/constants'
import { GigButtonState } from './types'

const START_PRESENTING_TEXT = `Start talk`
const END_PRESENTING_TEXT = `End talk`

const GO_LIVE_COLOUR = IconType.colour.primary
const END_LIVE_COLOUR = IconType.colour.secondary
const DISABLED_COLOUR = IconType.colour.tertiary

const GigButtonStates = (state: string): GigButtonState => {

  switch (state) {

    case status.UPCOMING:
    case status.T_MINUS_30:
    case status.RESCHEDULED:
    case status.CANCELLED:
      return {
        colour: GO_LIVE_COLOUR,
        text: START_PRESENTING_TEXT,
        disabled: true,
        visible: true,
        state: 'disabled'
      }
    case status.LIVE_ENABLED:
      return {
        colour: GO_LIVE_COLOUR,
        text: START_PRESENTING_TEXT,
        disabled: false,
        visible: true,
        state: 'start'
      }
    case status.GOING_LIVE:
      return {
        colour: DISABLED_COLOUR,
        text: START_PRESENTING_TEXT,
        disabled: true,
        visible: true,
        state: 'disabled'
      }
    case status.PRE_ROLL_INTERSTITIAL:
    case status.LIVE:
    case status.OVERRUN:
      return {
        colour: END_LIVE_COLOUR,
        text: END_PRESENTING_TEXT,
        disabled: false,
        visible: true,
        state: 'end'
      }
    case status.ENDING_LIVE:
      return {
        colour: DISABLED_COLOUR,
        text: END_PRESENTING_TEXT,
        disabled: true,
        visible: true,
        state: 'disabled'
      }
    case status.POST_ROLL_INTERSTITIAL:
    case status.COMPLETE:
    default:
      return {
        colour: DISABLED_COLOUR,
        text: '',
        disabled: true,
        visible: false,
        state: 'disabled'
      }

  }

}

export default GigButtonStates
